import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { User } from 'src/app/interfaces/user.interface';
import { ApiService } from 'src/app/services/api.service';

@Component({
  standalone: false,
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
})
export class UserListComponent implements OnInit {
  users: User[] | undefined;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadUsers();
  }

  async loadUsers() {
    try {
      const users = await this.apiService.fetchUsers();
      this.users = [...users];
    } catch (error) {
      handleApiError(this.authService, this.router, error);
    }
  }

  async onDeleteUser(id: number) {
    if (confirm('Benutzer wirklich löschen?')) {
      try {
        await this.apiService.deleteUser(id);
        this.loadUsers();
      } catch (error) {
        handleApiError(this.authService, this.router, error);
      }
    }
  }
}
